<template>
  <section class="accounts-component-template">
    <header class="act-header">
      <div class="act-header-title">
        <i class="act-icon" v-if="hasIcon" :style="{'background-color': color}">
          <slot name="icon"></slot>
        </i>
        <h3 v-html="componentName"></h3>
      </div>

      <div v-if="hasSearch">
        <div class="act-search">
          <slot
            name="search"
            :query="search.searchString"
            :placeholder="search.searchPlaceholder"
            :onSearch="onSearch">
            <input type="search" class="act-search-input" :placeholder="searchPlaceholder" />
          </slot>
        </div>
      </div>
    </header>
    <div class="act-content">
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script>
import moment from 'moment';

export default {

  props: {

    componentName: {
      type: String,
      default: 'Add component name...',
    },

    componentKey: {
      type: String,
      required: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Search...'
    },

    hasIcon: {
      type: Boolean,
      default: true
    },

    hasSearch: {
      type: Boolean,
      default: false
    },

    color: {
        type: String,
        default: '#666',
    }
  },

  data () {
    return {

      searchString: '',

      search: {
        searchString: '',
        placeholder: 'Search....'
      }
    }
  },

  computed: {},

  methods: {

    onSearch (input) {
      this.$emit(`component:${this.componentKey}:search`, input);
    }
  }
}
</script>
